var map = {
	"./circle_black.svg": 462,
	"./circle_blue.svg": 463,
	"./ellipse_black.svg": 464,
	"./france.svg": 279,
	"./highlighted_yellow.svg": 465,
	"./icone/carousel_new.svg": 506,
	"./icons/Cart.svg": 507,
	"./icons/Cart_add.svg": 508,
	"./icons/Cart_delete.svg": 509,
	"./icons/Cart_remove.svg": 510,
	"./icons/_info.svg": 511,
	"./icons/add_icon.svg": 283,
	"./icons/add_prod.svg": 512,
	"./icons/add_prodOLD.svg": 513,
	"./icons/ask.svg": 514,
	"./icons/carousel.svg": 355,
	"./icons/carrello.svg": 515,
	"./icons/categorie.svg": 516,
	"./icons/clear_chart.svg": 517,
	"./icons/close.svg": 199,
	"./icons/close_.svg": 518,
	"./icons/condividi.svg": 519,
	"./icons/email.svg": 357,
	"./icons/facebook.svg": 196,
	"./icons/hatchef.svg": 346,
	"./icons/icone/_info.svg": 520,
	"./icons/icone/book-open-solid.svg": 339,
	"./icons/icone/columns-solid.svg": 340,
	"./icons/icone/file-pdf-solid.svg": 342,
	"./icons/icone/hatchef.svg": 521,
	"./icons/icone/info.svg": 522,
	"./icons/icone/list-solid.svg": 345,
	"./icons/icone/magnifying-glass-solid.svg": 341,
	"./icons/icone/play.svg": 523,
	"./icons/icone/plus.svg": 524,
	"./icons/icone/share-square-solid-prod.svg": 344,
	"./icons/icone/share-square-solid.svg": 343,
	"./icons/icone/specs.svg": 525,
	"./icons/icone/world.svg": 526,
	"./icons/index-icon-bookmark.svg": 527,
	"./icons/index-icon.svg": 528,
	"./icons/info.svg": 354,
	"./icons/informazioni.svg": 529,
	"./icons/internal_link.svg": 358,
	"./icons/mappa.svg": 530,
	"./icons/markers-SVG/ask.svg": 531,
	"./icons/markers-SVG/info.svg": 532,
	"./icons/markers-SVG/list.svg": 533,
	"./icons/markers-SVG/recipe.svg": 534,
	"./icons/markers-SVG/web.svg": 535,
	"./icons/pagine.svg": 536,
	"./icons/pdf.svg": 537,
	"./icons/play.svg": 350,
	"./icons/play_ip.svg": 351,
	"./icons/plus.svg": 347,
	"./icons/plus_ip.svg": 348,
	"./icons/prodotti.svg": 538,
	"./icons/promo.svg": 353,
	"./icons/promo2.svg": 539,
	"./icons/promo3.svg": 540,
	"./icons/promo_10.svg": 541,
	"./icons/promo_classic.svg": 542,
	"./icons/remove_prod.svg": 543,
	"./icons/remove_prodOLD.svg": 544,
	"./icons/remove_prod_.svg": 545,
	"./icons/ricetta.svg": 546,
	"./icons/schermo_intero.svg": 547,
	"./icons/shop_list.svg": 548,
	"./icons/specs.svg": 352,
	"./icons/telephone.svg": 356,
	"./icons/video.svg": 549,
	"./icons/volantino.svg": 550,
	"./icons/whatsapp.svg": 197,
	"./icons/world.svg": 349,
	"./logo_catalog_interattivo.svg": 552,
	"./logo_interattivo.svg": 554,
	"./logo_interattivo_free.svg": 556,
	"./logo_interattivo_new.svg": 377,
	"./logo_menu_interattivo.svg": 557,
	"./logo_volantinointerattivo_free.svg": 378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1218;